<div #nepaliDatePicker class="nepali-date-picker" [ngClass]="{ dark: darkTheme }">
  <input class="np_datepicker_input" [ngClass]="{
      'np_datepicker_input--error': isError,
      'np_datepicker_input--active': isOpen
    }" type="text" [value]="calendarView == 'AD' ? formattedDateEnglish : formattedDate" (focus)="open()" (keydown.Tab)="close()" (keyup.escape)="close()" readonly aria-hidden="true"
    [placeholder]="placeholder" />
  <a *ngIf="clearable == true" (click)="clearSelectedDate()" class="cross-icon">
    <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve">
      <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 
	489.292,457.678 277.331,245.004 489.292,32.337 " />
    </svg>
  </a>
  <a class="form-icon" (click)="toggleOpen()" [ngClass]="isOpen ? 'active' : ''">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path
        d="M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z" />
    </svg>
  </a>
  <ng-container [ngTemplateOutlet]="datePicker" *ngIf="isOpen"></ng-container>
</div>
<!--.nepali-date-picker-->

<ng-template #datePicker>
  <div class="datepicker__container">
    <div class="datepicker__options-container">
      <a class="prev-month" (click)="prevMonth()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z" />
        </svg>
      </a>
      <span class="datepicker__options-month-container">
        <select class="datepicker__container__select" (change)="selectMonth($event)">
          <option *ngFor="
              let month of monthsMapping[language][monthDisplayType];
              index as i
            " [value]="month" [selected]="i === selectedMonthIndex">
            {{ month }}
          </option>
        </select>
      </span>
      <span class="datepicker__options-year-container">
        <select class="datepicker__container__select" (change)="selectYear($event)">
          <option *ngFor="let year of years; index as i" [value]="year" [selected]="year === selectedYear">
            {{ year | toNp : language : "number" }}
          </option>
        </select>
      </span>
      <span class="datepicker__options-year-container" *ngIf="hasMultipleCalendarView">
        <select class="datepicker__container__select" (change)="selectCalendarView($event,true)">
          <option *ngFor="let type of calendarType" [value]="type.value" [selected]="type.value === calendarView">
            {{ type.label }}
          </option>
        </select>
      </span>

      <a class="next-month" (click)="nextMonth()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z" />
        </svg>
      </a>
    </div>
    <div class="datepicker__days-container">
      <div class="datepicker__days" *ngFor="let day of daysMapping[language][dayDisplayType]; index as i">
        <div class="datepicker__weekday">{{ day }}</div>
        <ng-container [ngTemplateOutlet]="
            calendarView === 'BS' ? dateView : englishCalendar
          "></ng-container>
        <ng-template #dateView>
          <div class="datepicker__date-container" *ngFor="let date of currentMonthData[i]">
            <div *ngIf="!maxDate && !minDate; else viewWithDisabledDate">
              <div *ngIf="date" class="datepicker__date" [class.datepicker__date--active]="
                  selectedDate &&
                  date === selectedDate.day &&
                  currentNepaliDate.month === selectedDate.month &&
                  currentNepaliDate.year === selectedDate.year
                " [class.datepicker__date--current-day]="
                  date === nepaliDateToday.day &&
                  currentNepaliDate.month === nepaliDateToday.month &&
                  currentNepaliDate.year === nepaliDateToday.year
                " (click)="selectDate(date)">
                {{ date | toNp : language : "number" }}
              </div>
              <div *ngIf="!date" class="datepicker__date--initial-empty">
                <span>&nbsp;</span>
              </div>
            </div>

            <ng-template #viewWithDisabledDate>
              <div *ngIf="
                  date &&
                    ((minDate &&
                      !maxDate &&
                      nepaliMinDate.year * 365 +
                        nepaliMinDate.month * 30 +
                        nepaliMinDate.day <=
                        this.currentNepaliDate.year * 365 +
                          this.currentNepaliDate.month * 30 +
                          date) ||
                      (maxDate &&
                        !minDate &&
                        nepaliMaxDate.year * 365 +
                          nepaliMaxDate.month * 30 +
                          nepaliMaxDate.day >=
                          this.currentNepaliDate.year * 365 +
                            this.currentNepaliDate.month * 30 +
                            date) ||
                      (maxDate &&
                        minDate &&
                        nepaliMaxDate.year * 365 +
                          nepaliMaxDate.month * 30 +
                          nepaliMaxDate.day >=
                          this.currentNepaliDate.year * 365 +
                            this.currentNepaliDate.month * 30 +
                            date &&
                        nepaliMinDate.year * 365 +
                          nepaliMinDate.month * 30 +
                          nepaliMinDate.day <=
                          this.currentNepaliDate.year * 365 +
                            this.currentNepaliDate.month * 30 +
                            date));
                  else disabledDates
                " class="datepicker__date" [class.datepicker__date--active]="
                  selectedDate &&
                  date === selectedDate.day &&
                  currentNepaliDate.month === selectedDate.month &&
                  currentNepaliDate.year === selectedDate.year
                " [class.datepicker__date--current-day]="
                  date === nepaliDateToday.day &&
                  currentNepaliDate.month === nepaliDateToday.month &&
                  currentNepaliDate.year === nepaliDateToday.year
                " (click)="selectDate(date)">
                {{ date | toNp : language : "number" }}
              </div>

              <ng-template #disabledDates>
                <div *ngIf="date" class="datepicker__date datepicker__date--disabled">
                  {{ date | toNp : language : "number" }}
                </div>
                <div *ngIf="!date">
                  <span>&nbsp;</span>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </ng-template>
        <ng-template #englishCalendar>
          <div class="datepicker__date-container" *ngFor="let date of currentMonthData[i]">
            <div *ngIf="!maxDate && !minDate; else viewWithDisabledDate">
              <div *ngIf="date" class="datepicker__date" [class.datepicker__date--active]="
                  englishSelectedDate &&
                  date === englishSelectedDate.day &&
                  englishCurrentDate.month === englishSelectedDate.month &&
                  englishCurrentDate.year === englishSelectedDate.year
                " [class.datepicker__date--current-day]="
                  date === englishDateToday.day &&
                  englishCurrentDate.month === englishDateToday.month &&
                  englishCurrentDate.year === englishDateToday.year
                " (click)="selectDate(date)">
                {{ date | toNp : language : "number" }}
              </div>
              <div *ngIf="!date" class="datepicker__date--initial-empty">
                <span>&nbsp;</span>
              </div>
            </div>

            <ng-template #viewWithDisabledDate>
              <div *ngIf="
                  date &&
                    ((minDate &&
                      !maxDate &&
                      englishMinDate.year * 365 +
                        englishMinDate.month * 30 +
                        englishMinDate.day <=
                        englishCurrentDate.year * 365 +
                          englishCurrentDate.month * 30 +
                          date) ||
                      (maxDate &&
                        !minDate &&
                        englishMaxDate.year * 365 +
                          englishMaxDate.month * 30 +
                          englishMaxDate.day >=
                          englishCurrentDate.year * 365 +
                            englishCurrentDate.month * 30 +
                            date) ||
                      (maxDate &&
                        minDate &&
                        englishMaxDate.year * 365 +
                          englishMaxDate.month * 30 +
                          englishMaxDate.day >=
                          englishCurrentDate.year * 365 +
                            englishCurrentDate.month * 30 +
                            date &&
                        englishMinDate.year * 365 +
                          englishMinDate.month * 30 +
                          englishMinDate.day <=
                          englishCurrentDate.year * 365 +
                            englishCurrentDate.month * 30 +
                            date));
                  else disabledDates
                " class="datepicker__date" [class.datepicker__date--active]="
                  englishSelectedDate &&
                  date === englishSelectedDate.day &&
                  englishCurrentDate.month === englishSelectedDate.month &&
                  englishCurrentDate.year === englishSelectedDate.year
                " [class.datepicker__date--current-day]="
                  date === englishDateToday.day &&
                  englishCurrentDate.month === englishDateToday.month &&
                  englishCurrentDate.year === englishDateToday.year
                " (click)="selectDate(date)">
                {{ date | toNp : language : "number" }}
              </div>

              <ng-template #disabledDates>
                <div *ngIf="date" class="datepicker__date datepicker__date--disabled">
                  {{ date | toNp : language : "number" }}
                </div>
                <div *ngIf="!date">
                  <span>&nbsp;</span>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>